import React from "react";

export type DeleteIconProps = {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
};

export const DeleteIcon: React.FC<DeleteIconProps> = ({ onClick }) => {
  return (
    <svg
      width="12"
      height="12"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12.09 12.09"
      onClick={onClick}
    >
      <path
        d="M11.44,11.44l.35.35Zm-.71,0-.35.35Zm.71-.71.35-.35ZM6.75,6,6.4,5.69a.5.5,0,0,0,0,.71Zm4.69-4.68.35.35Zm0-.71.35-.36Zm-.71,0L10.38.29ZM6,5.34l-.35.35a.5.5,0,0,0,.71,0ZM1.36.65,1.71.29ZM.65.65.29.29Zm0,.71-.36.35ZM5.34,6l.35.36a.5.5,0,0,0,0-.71ZM.65,10.73l-.36-.35Zm0,.71-.36.35Zm.71,0,.35.35ZM6,6.75,6.4,6.4a.5.5,0,0,0-.71,0Zm5.05,4.34-.71.7a1,1,0,0,0,1.41,0Zm0,0,.7.7a1,1,0,0,0,0-1.41ZM6.4,6.4l4.68,4.68.71-.7L7.1,5.69ZM11.08,1,6.4,5.69l.7.71,4.69-4.69Zm0,0,.71.71a1,1,0,0,0,0-1.42h0Zm0,0,.71-.71a1,1,0,0,0-1.41,0ZM6.4,5.69,11.08,1l-.7-.71L5.69,5ZM1,1,5.69,5.69,6.4,5,1.71.29ZM1,1,1.71.29A1,1,0,0,0,.29.29h0ZM1,1,.29.29a1,1,0,0,0,0,1.42h0ZM5.69,5.69,1,1l-.71.71L5,6.4ZM1,11.08,5.69,6.4,5,5.69.29,10.38Zm0,0-.71-.7a1,1,0,0,0,0,1.41Zm0,0-.71.71a1,1,0,0,0,1.42,0h0ZM5.69,6.4,1,11.08l.71.71L6.4,7.1Zm5.39,4.68L6.4,6.4l-.71.7,4.69,4.69Z"
        style={{ fill: "#1e2731" }}
      />
    </svg>
  );
};
